import React from 'react'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
	message: {
		position: 'absolute',
		bottom: theme.spacing.unit * 2,
		left: '50%',
		transform: 'translate(-50%)',
		zIndex: theme.zIndex.onTopOfMap,
		padding: theme.spacing.unit,
		width: '80%',
		maxWidth: theme.spacing.unit * 32,
		textAlign: 'center'
	}
})

const MapMessage = ({ message, classes }) => (
	<Paper elevation={24} className={classes.message}>
		<Typography variant="body1">
			{message}
		</Typography>
	</Paper>
)

const StyledMapMessage = withStyles(styles)(MapMessage)

export default ({ message }) => message ? <StyledMapMessage message={message} /> : null



// WEBPACK FOOTER //
// ./src/components/MapMessage/MapMessage.js